import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Layout from './features/dashboard/Layout';
import Dashboard from './features/dashboard/Dashboard';
import FutureValueCalculator from './features/calculators/FutureValueCalculator';
import Breadcrumbs from './components/ui/Breadcrumbs';
import Interest from './features/chapters/Interest';

// Placeholder components for routes that don't exist yet
const Calculators = () => <div>Calculators Page (Placeholder)</div>;
const About = () => <div>About Page (Placeholder)</div>;

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={
          <Layout breadcrumbs={<Breadcrumbs items={[{ label: 'Home', path: '/' }]} />}>
            <Dashboard />
          </Layout>
        } />
        <Route path="/calculators" element={
          <Layout breadcrumbs={<Breadcrumbs items={[{ label: 'Home', path: '/' }, { label: 'Calculators', path: '/calculators' }]} />}>
            <Calculators />
          </Layout>
        } />
        <Route path="/about" element={
          <Layout breadcrumbs={<Breadcrumbs items={[{ label: 'Home', path: '/' }, { label: 'About', path: '/about' }]} />}>
            <About />
          </Layout>
        } />
        <Route path="/calculators/future-value" element={
          FutureValueCalculator.getLayout(<FutureValueCalculator />)
        } />
        <Route path="/interest-calculators" element={
          <Layout breadcrumbs={<Breadcrumbs items={[{ label: 'Home', path: '/' }, { label: 'Interest Calculators', path: '/interest-calculators' }]} />}>
            <Interest />
          </Layout>
        } />
      </Routes>
    </Router>
  );
};

export default App;